/**
 * QuoteReferencesDossier.jsx — les quatre references du dossier.
 *
 * Convention, OPCO, dossier, commande : **c'est ce qu'un financeur rappelle
 * pour payer**, et rien ne les portait. Le document les imprime depuis la
 * refonte des editions, et **aucun ecran ne permettait de les saisir** : elles
 * restaient donc vides sur toutes les pieces.
 *
 * Elles appartiennent au **dossier**, pas a la prestation : d'ou leur place
 * au-dessus des notes et non dans le tableau des lignes.
 *
 * **Chacune ne s'imprime que si elle est remplie** — « Convention : » suivi de
 * rien serait une maquette partie chez le client.
 *
 * Purement presentationnel — ne detient aucun etat.
 */
import React from 'react';

const CASE = 'w-full h-9 px-2.5 rounded-lg bg-[#F6F7FB] border border-[#EFF0F6] ' +
  'text-[12.5px] focus:bg-white focus:border-[#4F46E5] outline-none';
const INTITULE = 'block text-[10px] font-semibold text-[#8E8FA5] uppercase ' +
  'tracking-wide mb-0.5';

export default function QuoteReferencesDossier({
  conventionRef, onConventionRef,
  opcoRef, onOpcoRef,
  dossierRef, onDossierRef,
  commandeRef, onCommandeRef,
}) {
  const champs = [
    ['N° de convention', conventionRef, onConventionRef, 'quote-ref-convention'],
    ['OPCO / financeur', opcoRef, onOpcoRef, 'quote-ref-opco'],
    ['N° de dossier', dossierRef, onDossierRef, 'quote-ref-dossier'],
    ['N° de commande / bon', commandeRef, onCommandeRef, 'quote-ref-commande'],
  ];
  return (
    <section data-testid="quote-references">
      <label className="block text-[11.5px] font-semibold text-[#6B6C85] uppercase tracking-wide mb-1.5">
        Références du dossier
      </label>
      <div className="grid grid-cols-2 gap-2">
        {champs.map(([intitule, valeur, poser, marque]) => (
          <div key={marque}>
            <span className={INTITULE}>{intitule}</span>
            <input
              value={valeur || ''}
              onChange={(e) => poser(e.target.value)}
              data-testid={marque}
              className={CASE}
            />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-[#8E8FA5] mt-1.5">
        Imprimées sur le document, et seulement celles que vous remplissez.
      </p>
    </section>
  );
}
